import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  deleteSeasonRateRuleReleaseIntervalAsync,
  getSeasonRateReleaseIntervalRuleAsync,
  selectReleaseIntervalRuleDetails,
  selectReleaseIntervalRuleDetailsLoadingStatus,
  updateSeasonRateReleaseIntervalRuleAsync,
} from '../seasonRateRulesSlice';
import RateReleaseIntervalForm from './RateReleaseIntervalForm';
import { ReleaseIntervalRuleDetails } from '../../../common/types/rates.types';

function SeasonRateReleaseInterval({
  seasonRateId,
  hasWriteAccess,
}: {
  seasonRateId: string;
  hasWriteAccess: boolean;
}) {
  const dispatch = useAppDispatch();
  const releaseIntervalRuleDetails = useAppSelector(
    selectReleaseIntervalRuleDetails,
  );
  const releaseIntervalItemStatus = useAppSelector(
    selectReleaseIntervalRuleDetailsLoadingStatus,
  );

  const initialData: ReleaseIntervalRuleDetails = {
    seasonRateId,
    daysUntilRelease: null,
    releaseLengthOfStayRule: true,
    releaseWeekdayMinimumStayRules: true,
    releaseWeekdayCheckOutRules: true,
    releaseWeekdayCheckInRules: true,
    isActive: true,
    isCopyable: true,
  };

  const [data, setData] = useState(initialData);
  const [submitted, setSubmitted] = useState(false);
  const [deleted, setDeleted] = useState(false);

  useEffect(() => {
    dispatch(getSeasonRateReleaseIntervalRuleAsync(seasonRateId));
  }, [dispatch, seasonRateId]);

  useEffect(() => {
    if (
      releaseIntervalRuleDetails &&
      releaseIntervalRuleDetails.seasonRateId === seasonRateId
    ) {
      setData(releaseIntervalRuleDetails);
    } else {
      setData(initialData);
    }
  }, [releaseIntervalRuleDetails]);

  const handleInputChange = event => {
    const path = event.target.name.split('.');
    const finalProp = path.pop();
    const newData = { ...data };
    let pointer = newData;
    path.forEach(el => {
      pointer[el] = { ...pointer[el] };
      pointer = pointer[el];
    });
    pointer[finalProp] =
      event.target.type === 'checkbox'
        ? event.target.checked
        : event.target.value;
    setData(newData);
  };

  const onSubmit = () => {
    dispatch(updateSeasonRateReleaseIntervalRuleAsync(data));
    setSubmitted(true);
  };

  const onDelete = () => {
    if (window.confirm('Haluatko varmasti poistaa säännön?')) {
      dispatch(deleteSeasonRateRuleReleaseIntervalAsync(data.id));
      setSubmitted(false);
      setData(initialData);
      setDeleted(true);
    }
  };

  return (
    <RateReleaseIntervalForm
      loadingStatus={releaseIntervalItemStatus}
      handleInputChange={handleInputChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitted={submitted}
      deleted={deleted}
      data={data}
      hasWriteAccess={hasWriteAccess}
    />
  );
}

export default SeasonRateReleaseInterval;
